import { LabelValue } from "types";

import { OrderStatus, RegionType, StripeCurrency } from "graphql/generated";
import { COUNTRY_CODES, CURRENT_COUNTRY } from "src/constants/Countries";

export const DATE_TIME_FORMAT = "yyyy-MM-DD hh:mm:ss A";
export const DATE_FORMAT = "yyyy-MM-DD";
export const DATE_INPUT_VALIDATION = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
export const MAX_DOB_YEAR = "2005";

export const TIME_BY_COUNTRY = {
  [RegionType.Jp]: "Ahh:mm",
  [RegionType.Sg]: "hh:mm A",
  [RegionType.Hk]: "hh:mm A"
};

export const DEFAULT_DATE_FORMAT_BY_COUNTRY = {
  [COUNTRY_CODES.SG]: "DD/MM/YYYY",
  [COUNTRY_CODES.HK]: "DD/MM/YYYY",
  [COUNTRY_CODES.JP]: "YYYY/MM/DD"
};
export const DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT_BY_COUNTRY[CURRENT_COUNTRY];

export const WEEK_DAY_FORMAT_BY_COUNTRY = {
  [COUNTRY_CODES.SG]: "DD/MM/YYYY, ddd",
  [COUNTRY_CODES.HK]: "DD/MM/YYYY, ddd",
  [COUNTRY_CODES.JP]: "YYYY/MM/DD (ddd)"
};

export const WEEK_DAY_FORMAT = WEEK_DAY_FORMAT_BY_COUNTRY[CURRENT_COUNTRY];

export const HYPHEN_DATE_FORMAT_BY_COUNTRY = {
  [RegionType.Jp]: "YYYY-MM-DD",
  [RegionType.Sg]: "DD-MM-YYYY",
  [RegionType.Hk]: "DD-MM-YYYY"
};

export const HYPHEN_DATE_FORMAT = HYPHEN_DATE_FORMAT_BY_COUNTRY[CURRENT_COUNTRY];

export const MMM_DATE_FORMAT_BY_COUNTRY = {
  [RegionType.Jp]: "YYYY-MM-DD", // not show Month Text in Japan
  [RegionType.Sg]: "DD MMM YYYY",
  [RegionType.Hk]: "DD MMM YYYY"
};

export const MMM_DATE_FORMAT_BY_COUNTRY_WITH_SPACE = {
  [RegionType.Jp]: "LL", // 2022年10月13日
  [RegionType.Sg]: "DD MMM YYYY",
  [RegionType.Hk]: "DD MMM YYYY"
};

export const MMM_DATE_FORMAT = MMM_DATE_FORMAT_BY_COUNTRY[CURRENT_COUNTRY];

export const MMMM_DATE_FORMAT_BY_COUNTRY = {
  [RegionType.Jp]: "YYYY-MM-DD", // not show Month Text in Japan
  [RegionType.Sg]: "DD MMMM YYYY",
  [RegionType.Hk]: "DD MMMM YYYY"
};

export const MMMM_DATE_FORMAT = MMMM_DATE_FORMAT_BY_COUNTRY[CURRENT_COUNTRY];

export const MMM_WEEK_DAY_FORMAT_BY_COUNTRY = {
  [RegionType.Jp]: "YYYY-MM-DD (ddd)", // not show Month Text in Japan
  [RegionType.Sg]: "DD MMM YYYY, ddd",
  [RegionType.Hk]: "DD MMM YYYY, ddd"
};

export const MMM_WEEK_DAY_FORMAT = MMM_WEEK_DAY_FORMAT_BY_COUNTRY[CURRENT_COUNTRY];

export const MMMM_WEEK_DAY_FORMAT_BY_COUNTRY = {
  [RegionType.Jp]: "YYYY-MM-DD (ddd)", // not show Month Text in Japan
  [RegionType.Sg]: "DD MMMM YYYY, ddd",
  [RegionType.Hk]: "DD MMMM YYYY, ddd"
};

export const MMMM_WEEK_DAY_FORMAT = MMMM_WEEK_DAY_FORMAT_BY_COUNTRY[CURRENT_COUNTRY];

export const TIMEZONE = process.env.NEXT_PUBLIC_TIMEZONE;

const CURRENCY_LABELS = {
  [RegionType.Sg]: "SGD",
  [RegionType.Hk]: "HKD",
  [RegionType.Jp]: "JPY"
};

const CURRENCY_VALUES = {
  [RegionType.Sg]: StripeCurrency.Sgd,
  [RegionType.Hk]: StripeCurrency.Hkd,
  [RegionType.Jp]: StripeCurrency.Jpy
};

export const dateFormat = {
  dateTime: "YYYY-MM-DDTHH:mm:ss.SSSZ",
  date: "YYYY-MM-DD"
};

export const CURRENCY_LABEL = CURRENCY_LABELS[CURRENT_COUNTRY];

export const CURRENT_CURRENCY: StripeCurrency = CURRENCY_VALUES[CURRENT_COUNTRY];

export const COMPANY_NAME = "Noah Health Pte Ltd";

export const COMPANY_ADDRESS = "27 W Coast Hwy #02-22 S117867";

export const DEFAULT_PHONE = {
  [RegionType.Sg]: "+65 69800905",
  [RegionType.Jp]: "+81 050-3134-4343",
  [RegionType.Hk]: "+852 2319 4109"
};

export const phoneRegExp = {
  [RegionType.Hk]: /^[2,3,4,5,6,7,8,9][0-9]{7,10}$/,
  [RegionType.Sg]: /^[3,6,8,9][0-9]{7}$/,
  [RegionType.Jp]: /^[0-9-]{10,13}$/
};

export const CURRENCY_OPTIONS: LabelValue[] = [
  {
    label: CURRENCY_LABELS[RegionType.Sg],
    value: StripeCurrency.Sgd
  },
  {
    label: CURRENCY_LABELS[RegionType.Hk],
    value: StripeCurrency.Hkd
  },
  {
    label: CURRENCY_LABELS[RegionType.Jp],
    value: StripeCurrency.Jpy
  }
];

export const SUPER_ADMIN_EMAILS: string[] = [
  "angeline@ordinaryfolk.health",
  "ben@ordinaryfolk.health",
  "priya@ordinaryfolk.health",
  "ezra@ordinaryfolk.health"
];

export const SYNCABLE_STRIPE_EMAILS: string[] = ["ezra@ordinaryfolk.health"];

export const ORDER_STATUS_PENDING_BOOKING_GROUP: OrderStatus[] = [
  OrderStatus.PendingBooking,
  OrderStatus.PendingBookingFu
];

export const ORDER_STATUS_PENDING_PRESCRIPTION_GROUP: OrderStatus[] = [
  OrderStatus.PendingPrescription,
  OrderStatus.PendingPrescriptionFu
];
